"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.storeFrontAPI = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
  Helper to utilize and access the Shopify StoreFront API and query GraphQL.

  @param {object} config - Object containing a shop and token properties
  @param {object} payload - Contains a GraphQL query and additional variables
  @param {sting} version - Override to specify version of GraphQL endpoint

  @return {Promise} A jQuery Deferred promise will be returned
*/
var storeFrontAPI = function storeFrontAPI(_ref) {
  var _ref$shop = _ref.shop,
      shop = _ref$shop === void 0 ? '' : _ref$shop,
      _ref$token = _ref.token,
      token = _ref$token === void 0 ? '' : _ref$token;
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "2020-07";
  return _jquery["default"].ajax({
    method: 'post',
    dataType: 'json',
    data: JSON.stringify(payload, null, 2),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      // prettier-ignore
      'X-Shopify-Storefront-Access-Token': token
    },
    url: "//".concat(shop, "/api/").concat(version, "/graphql.json")
  });
};

exports.storeFrontAPI = storeFrontAPI;
var _default = storeFrontAPI;
exports["default"] = _default;